import React from 'react';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { currentUploadStep, stepsUpload } from '../../common/atom/atoms';
import CheckIcon from '@mui/icons-material/Check';

export default function NavBarForUpload() {
  const currentStep = useAtomValue(currentUploadStep);
  const steps = useAtomValue(stepsUpload);
  return (
    <Box
      sx={{
        width: '100%',
        minWidth: 600,
        height: 52,
        position: 'relative',
        background: '#F5F5F5',
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '8%',
          transform: 'translateY(-50%)',
          display: 'flex',
          alignItems: 'center',
          width: '84%',
        }}
      >
        {steps.map((text, index) => (
          <React.Fragment key={text}>
            <Box
              sx={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                outline: `1px solid ${index <= currentStep ? '#BD1D23' : '#ABB7C2'}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: index < currentStep ? '#BD1D23' : 'transparent',
                color: index < currentStep ? '#fff' : index === currentStep ? '#BD1D23' : '#ABB7C2',
                fontSize: 14,
                fontWeight: 500,
                fontFamily: 'Roboto',
              }}
            >
              {index < currentStep ? <CheckIcon sx={{ fontSize: 16 }} /> : index + 1}
            </Box>
            <Typography
              sx={{
                color: index === currentStep ? '#0D0B26' : '#ABB7C2',
                fontSize: 14,
                fontWeight: 500,
                fontFamily: 'Roboto',
                whiteSpace: 'nowrap',
                marginLeft: '1%',
              }}
            >
              {text}
            </Typography>
            {index < steps.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  background: '#0D0B26',
                  mx: 2,
                  height: '1px',
                  opacity: '0.3',
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
}
